export default __webpack_public_path__ + "static/media/mahebeach01.60c231d5.jpg";